import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { ApplicationsService } from '../../services/applications/applications.service';

export const applicationsLoadedResolver: ResolveFn<void> = () => {
  const applicationsService = inject(ApplicationsService);

  if (applicationsService.applicationIdSelected !== 0) {
    return;
  }

  return firstValueFrom(applicationsService.applicationsLoadedSubject);
};
